export function splitPurchasesPerType(purchases = []) {
  const result = {};
  purchases
    .filter((p) => !p.resourceId)
    .forEach((p) => {
      if (!result[p.type]) {
        result[p.type] = [];
      }

      result[p.type].push(p);
    });

  return result;
}
